import { onSearchTextChanged } from '../actions/publicActions';
import { orchestrator } from 'satcheljs';
import { setSearchText, updateGhostText } from '../actions/internalActions';

export default orchestrator(onSearchTextChanged, async actionMessage => {
    const { scenarioId, searchText } = actionMessage;

    // Always set the search text in response to search box text changing.
    setSearchText(searchText, scenarioId);

    /**
     * Update ghost text (ensure new search text is prefix of current ghosted
     * suggestion).
     */
    updateGhostText(scenarioId);
});
